import type { NodeAssociation } from "@skilitics/nautilus-core-designer-data";

import type { GetDesignerNodeById } from "./getDesignerNodeById.ts";

export const populateNodeOnNodeAssociationsCreate =
  (getNodeById: GetDesignerNodeById) => (associations: NodeAssociation[]) =>
    associations.map(({ nodeId: id, ...rest }) => ({ node: getNodeById(id), ...rest }));

export type PopulateNodeOnNodeAssociations = ReturnType<typeof populateNodeOnNodeAssociationsCreate>;
